/**
 * 统一 API 层共享类型。
 * 后端统一响应 { code: 0, msg, data }；分页 data = { list, total }；字段 snake_case。
 * 页面一律经 src/api/* 访问后端，不直接裸调 request。
 */

/** 分页结果 */
export interface Page<T> {
  list: T[];
  total: number;
}

/** 分页查询参数（后端认 page/pageSize） */
export interface PageQuery {
  page?: number;
  pageSize?: number;
}

/** 归一化分页响应，兼容直接返回数组的兜底 */
export function toPage<T = any>(data: any): Page<T> {
  if (Array.isArray(data)) return { list: data as T[], total: data.length };
  if (data && Array.isArray(data.list)) {
    return { list: data.list as T[], total: Number(data.total) || data.list.length };
  }
  return { list: [], total: 0 };
}
